module.exports = __webpack_public_path__ + "img/dibubg1.132f01b5.png";